module.exports = __webpack_public_path__ + "static/media/traffic-severe.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/traffic-severe.svg
// module id = 927
// module chunks = 0